<template>
  <div>
      <div>
        <br />
        <table class="table table-responsive-xs">
          <thead>
            <tr>
              <th class="title-header text-center">Seq</th>
              <th class="title-header">Tipo</th>
              <th class="title-header text-center">Valor</th>
              <th class="title-header text-center">Vencimento</th>
              <th></th>
            </tr>
          </thead>
          <tbody v-for="payment in paymentsRent" :key="payment.seq">
            <tr>
              <td class="text-center">
                <span class="seq"> {{ payment.seq }}</span>
              </td>
              <td class="tabela-principal tabela-descricao" @click="update(payment)">
                <span> {{ payment.typePayment.content }}</span>
                <span v-if="payment.bankAccount">
                  <span v-if="payment.bankAccount.content">
                    ({{ payment.bankAccount.content }})
                  </span>
                </span>
              </td>
              <td class="editavel tabela-principal text-center" @click="update(payment)">
                <span> {{ payment.value | currency }} </span>
              </td>
              <td class="editavel tabela-principal tabela-descricao text-center" @click="update(payment)">
                <span>{{ payment.dueDate }}</span>
              </td>
              <td class="text-center" @click="remove(payment)">
                <span class="icone">
                  <i class="fas fa-times-circle"></i>
                </span>
              </td>
            </tr>
            <tr v-show="seq == payment.seq">
              <td colspan="7">
                <PaymentUpdate :payment="payment" />
              </td>
            </tr>
          </tbody>
          <tbody v-show="paymentsRent.length == 0">
            <tr>
              <td colspan="12">
                <span>Nenhum pagamento adicionado!</span>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
  </div>
</template>

<script>

import PaymentUpdate from "./PaymentUpdate.vue";

import { mapState, mapMutations, mapActions, mapGetters } from "vuex";

export default {
  components: {
    PaymentUpdate,
  },
  name: "PaymentsList",
  data() {
    return {
      seq: 0,
      urlDeleteAllApi: "/api/v1/rental/payment-rent/delete"
    };
  },
  computed: {
    ...mapState("paymentShared", ["paymentsRent"]),
    ...mapGetters("generic", ["event"]),
  },
  methods: {
    ...mapActions("generic", ["deleteAllApi"]),
    ...mapMutations("generic", ["addEvent", "removeLoading"]),
    ...mapMutations("paymentShared", ["removePayment"]),
    update(payment) {
      this.seq = payment.seq;
    },
    remove(payment) {
      let self = this;
      setTimeout(function () {
        self.seq = 0;
      }, 300);
      this.removePayment(payment.seq);
      this.delete(payment.id);
    },
    delete(id) {
      let params = {
        url: this.urlDeleteAllApi,
        selected: [id],
      };
      this.deleteAllApi(params).then(() => { });
    },
  },
  watch: {
    event: {
      handler(event) {
        if (event.name == "paymentRentCancelUpdate") {
          this.seq = 0;
          this.removeLoading(["btnUpdatePayment", "btnCancelPayment"]);
        }
      },
      deep: true,
    },
  },
};
</script>
<style scoped>
.table th,
.table td {
  height: 10px !important;
  padding-left: 5px !important;
  padding-top: 7px !important;
  padding-bottom: 5px !important;
  padding-right: 5px !important;
  padding-left: 10px !important;
  border-bottom: 0px !important;
}

.title-header {
  font-size: 14px;
  color: #757d8c;
  font-weight: 400;
  text-transform: uppercase;
}

.tabela-principal {
  font-size: 14px;
  max-width: 200px;
}

.tabela-descricao {
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  max-width: 200px;
}

.descricao {
  font-size: 13px;
  color: darkgray;
}

.seq {
  margin-right: 5px;
  font-size: 15px;
}

.icone {
  font-size: 20px;
  color: #f0134d;
  cursor: pointer;
}

.icone:hover {
  color: #c70f40;
}

.editavel {
  cursor: pointer;
  background-color: #f1f4f9;
}
</style>
